const config = {
    API_URL: process.env.REACT_APP_API_URL || '',
    WS_URL: process.env.REACT_APP_WS_URL || 'ws://localhost:3001'
};

export default config;
